import { render } from "./NotificationLogs.vue?vue&type=template&id=7f18b84a&scoped=true"
import script from "./NotificationLogs.vue?vue&type=script&lang=js"
export * from "./NotificationLogs.vue?vue&type=script&lang=js"

import "./NotificationLogs.vue?vue&type=style&index=0&id=7f18b84a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f18b84a"]])

export default __exports__